'use client'
import React from 'react'
import { PylonContext } from './context'
import { PylonContextValues } from './types'

export function usePylon() {
  const context = React.useContext(PylonContext)
  if (context === undefined) {
    throw new Error(`"usePylon" must be used within "PylonProvider"`)
  }
  return context as PylonContextValues
}
